module.exports = __webpack_public_path__ + "static/media/pennbook.ffcd94d2.png";